"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var __1 = require("../../");
var formik_1 = require("formik");
var PasswordForm = function (_a) {
    var loadErrors = _a.loadErrors;
    var trans = context_1.useSemantics().trans;
    var _b = formik_1.useFormikContext(), errors = _b.errors, setErrors = _b.setErrors;
    react_1.useEffect(function () { return setErrors(loadErrors); }, [loadErrors]);
    return (react_1.default.createElement(__1.Card, { footer: react_1.default.createElement(__1.Button, { type: __1.ButtonType.submit }, trans('optiiva::labels.update-password')) },
        react_1.default.createElement(__1.FormControl, { label: trans('optiiva::labels.password'), className: "w-full", errors: errors.password, dusk: "password-field" },
            react_1.default.createElement(__1.Input, { dusk: "password", name: "password", type: __1.InputType.password })),
        react_1.default.createElement(__1.FormControl, { label: trans('optiiva::labels.confirm-password'), className: "w-full", errors: errors.password_confirmation, dusk: "confirm-password" },
            react_1.default.createElement(__1.Input, { dusk: "confirm-password", name: "password_confirmation", type: __1.InputType.password }))));
};
var PasswordManagementPage = function (_a) {
    var errors = _a.errors, onSubmit = _a.onSubmit, values = _a.values;
    return (react_1.default.createElement("div", { className: "w-full max-w-xl" },
        react_1.default.createElement(__1.FormProvider, { initialValues: values, onSubmit: onSubmit },
            react_1.default.createElement(__1.Form, { "data-dusk": "password-management-form" },
                react_1.default.createElement(PasswordForm, { loadErrors: errors })))));
};
exports.default = PasswordManagementPage;
//# sourceMappingURL=index.js.map